export enum ILandingPage {
    BASIC = 'BASIC',
    SPONSOR = 'SPONSOR',
    // TYPETHREE = 'TYPETHREE',
  }
  
  export enum IRegistrationAndCheckInType {
    NO_REGISTRATION = 'NO_REGISTRATION',
    REGISTRATION = 'REGISTRATION',
    DIRECT_CHECKIN = 'DIRECT_CHECKIN',
    INVITE_ONLY = 'INVITE_ONLY',
    EMAIL = 'EMAIL',
    OTP_EMAIL = 'OTP_EMAIL',
    NAME = 'NAME',
    DEFAULT_FORM = 'DEFAULT_FORM',
    CUSTOM_FORM = 'CUSTOM_FORM',
    CUSTOM_FORM_DAYS = 'CUSTOM_FORM_DAYS',
    OTP_EMAIL_REGISTRATION = 'OTP_EMAIL_REGISTRATION',
    OTP_EMAIL_DIRECT_REGISTRATION = 'OTP_EMAIL_DIRECT_REGISTRATION',
    SSO_EMAIL_DIRECT_CHECKIN = 'SSO_EMAIL_DIRECT_CHECKIN',
  }
  
  export enum IEventCheckinType {
    REGISTRATION = 'REGISTRATION',
    DIRECT_CHECKIN = 'DIRECT_CHECKIN',
    INVITE_ONLY = 'INVITE_ONLY',
    TICKETING = 'TICKETING',
  }
  
  export enum ITemplateType {
    SPONSOR = 'SPONSOR',
  }
  
  // NOTE - this enum almost matches the "AuthMode" enum on the backend
  export enum ILoginType {
    EMAIL = 'EMAIL',
    EMAIL_OTP = 'EMAIL_OTP',
    SSO = 'SSO',
    GOOGLE = 'GOOGLE',
    FACEBOOK = 'FACEBOOK',
    LINKEDIN = 'LINKEDIN',
    // NOTE- this is not yet implemented with the new auth
    GUEST = 'GUEST',
  }
  
  export const IFormTypeSelection = [
    {
      label: 'Registration',
      value: IEventCheckinType.REGISTRATION,
    },
    {
      label: 'Direct Check In',
      value: IEventCheckinType.DIRECT_CHECKIN,
    },
    {
      label: 'Invite Only (Private Event)',
      value: IEventCheckinType.INVITE_ONLY,
    },
  ];
  
  export type ITemplateDetails = {
    allowDayWiseRegistration: boolean;
    allowRegistrationAfterEventStart: boolean;
    backgroundImageUrl: string;
    checkInEnableTime: number;
    disclaimerMessage: string | null;
    eventEntryType: IEventCheckinType;
    eventId: string;
    eventLandingPageId: string;
    eventLandingPageSponsorDTOList: any;
    formBgColour: string;
    formFontColour: string;
    isCountDownRequired: boolean;
    isDisclaimerRequired: any;
    isPromptRequired: any;
    isSpeakerLandingPageSame: any;
    landingPageTemplateName: ILandingPage;
    logoImageUrl: string | null;
    logoImageUrlTwo: string | null;
    promptMessage: string | null;
    registrationCustomFieldList: {}[] | null;
    guestModeEnabled: boolean;
    attendeeAuthType: any;
    speakerAuthType: any;
  };
  
  interface ILandingPageNoBackgroundStyle {
    color: string;
  }
  export interface ILandingPageCounterNoBackgroundStyle extends ILandingPageNoBackgroundStyle {}
  
  
  
  interface ILandingPageStyle {
    backgroundColor: string;
    color: string;
  }
  
  export interface ILandingPageCounterStyle extends ILandingPageStyle {}
  export interface ILandingPageFormContainerStyle extends ILandingPageStyle {}
  export interface ILandingPageButtonStyle extends ILandingPageStyle {}
  

export enum IRegistrationPageSource {
  LANDING_PAGE_V1 = 'LANDING_PAGE_V1',
  LANDING_PAGE_V2 = 'LANDING_PAGE_V2',
  DUDA_REGISTRATION_FORM = 'DUDA_REGISTRATION_FORM',
  DUDA_TICKETING_BUYER = 'DUDA_TICKETING_BUYER',
  DUDA_TICKETING_MAPPING = 'DUDA_TICKETING_MAPPING',
  EMBED_REGISTRATION_FORM = 'EMBED_REGISTRATION_FORM',
  TICKETING_BUYER = 'TICKETING_BUYER',
  TICKETING_MAPPING = 'TICKETING_MAPPING',
  BULK_IMPORT = 'BULK_IMPORT',
  ATTENDEE_INVITE = 'ATTENDEE_INVITE',
  ATTENDEE_ADD_FORM = 'ATTENDEE_ADD_FORM',
  UNKNOWN = 'UNKNOWN',
}
